export default __webpack_public_path__ + "static/media/DowneSinglePointofContactforUCC&RACv1.1220526DowneSPoCforUCC&RACv1_1_flowchart.81c72e21.jpg";